<!-- 列表页公共导航栏 -->
<template>
    <nav class="page_nav shadow">
        <div class="main_wrap nav_wrap flex_justify_between">
            <div class="logo"></div>
            <div class="flex_align">
                <ul class="navList flex_wrap">
                    <li
                        class="item"
                        :class="{'active':nav.src==router}"
                        v-for="(nav,index) in navData"
                        :key="index"
                        @click="changeRouter(nav)">
                        {{nav.title}}
                    </li>
                </ul>
                <!-- <div class="menu" :class="{'menu-tender':router=='/page/report'}" @click="showFullSwiper"></div> -->
                <div class="menu menu-tender" @click="showFullSwiper"></div>
            </div>
        </div>
    </nav>
</template>

<script>
    import permission from "@/mixins/permission.js";
    export default {
        mixins:[permission],
        props:{
            indexUrl:{
                type:String,
                default(){
                    return ''
                }
            }
        },
        data() {
            return {
                navData:[
                    { title:"房企拿地监控", src:'/page/land',show:[1,2],role:1},//show表示当前模块可显示的userType
                    { title:"房企项目开工监控", src:'/page/project',show:[1,2],role:2},
                    { title:"全装修市场监控", src:'/page/market',show:[1,2],role:3},
                    { title:"采购大数据服务系统", src:'/page/tender',show:[0,1,2],role:4, active:false},
                    { title:"研究报告", src:'/page/report',show:[1,2],role:5},
                ]
            }
        },
        computed: {
            router(){
                let _myRoute=this.$route.path;
                console.log(_myRoute)
                // 针对详细页面 导航active
                // module代表页面模块类型 1 房企拿地 2 房企项目开发 3全装修市场监控 4招标采购	
                if(this.$route.query.module){
                    _myRoute=this.navData[this.$route.query.module-1].src
                }
                // 针对研究报告详情页
                if(_myRoute=='/page/report/detail'){
                    _myRoute='/page/report'
                }
                return _myRoute
            },
        },
        created() {
            
        },
        // watch:{
        //     $route(to,from){
        //         let router = this.$route.path.split('/')
        //         console.log(router);
        //         // this.refreshSet(to.path.split('/')[1]);
        //     }
        // },
        methods: {
            changeRouter(obj){
                
                if(obj.show.indexOf(Number(this.userType))==-1 ||  (this.sUserRole.length>0 &&   !this.sUserRole.includes(obj.role)) ){
                    this.showTip();
                    return
                }
                if(obj.role === 4) {
                    window.open(this.indexUrl, '_blank')
                }else{
                    this.$router.push({
                        path: obj.src,
                    })
                }
                
            },
            showFullSwiper(){
                if(this.userType==0){
                    this.showTip();
                    return
                }
                this.$emit('showFullSwiper');
            },
        }
    }
</script>

<style lang="scss" scoped>
.page_nav{
    width: 100%;
    height: 7.4vh;
    background: url('../assets/imgs/nav_bg.png') 0 0 no-repeat #E1F5FE;
    background-size: cover;

    .nav_wrap{ height: 100%;}

    // logo
    .logo{
        width: 2.05rem;
        height: .35rem;
        background-image: url('../assets/imgs/logo_page.png');
        background-size: 100%;
        background-repeat: no-repeat;
        margin-top: .05rem;
    }

    .navList{
        .item{
            font-size: .14rem;
            line-height: 2.4;
            padding: 0 .05rem;
            margin-right: .2rem;
            color: #999;
            cursor: pointer;
            &.active{
                color: #1D2531;
                border-bottom: .02rem solid #00A4DF;
            }
        }
    }

    .menu{
        width: .34rem;
        height: .34rem;
        background-image: url('../assets/imgs/menu_page.png');
        background-size: 100% 100%;
        cursor: pointer;
        z-index: 1000;
        &.menu-tender{
            width: .36rem;
            height: .49rem;
            background-image: url('../assets/imgs/menu_page2.png');
        }
    }
}
</style>
